<template>
	<div
		class="materials-slider"
		:class="{ 'materials-slider--scroll': shouldScroll }"
	>
		<div v-if="items.length === 0" class="materials-slider__empty">
			<div class="materials-slider__empty-text">Пусто</div>
		</div>

		<div
			v-else
			class="materials-slider__grid"
			:class="{ 'materials-slider__grid--scroll': shouldScroll }"
			:style="gridStyle"
		>
			<slot
				v-for="item in items"
				:key="item.id"
				:item="item"
				name="card"
			></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'MaterialsSlider',
	props: {
		items: {
			type: Array,
			default: () => [],
		},
		itemsPerPage: {
			type: Number,
			default: 12,
		},
		columns: {
			type: Number,
			default: 4,
		},
	},
	computed: {
		gridStyle() {
			return { '--ms-cols': this.columns }
		},
		shouldScroll() {
			return this.items.length > 10
		},
	},
}
</script>

<style scoped>
.materials-slider {
	position: relative;
	width: 100%;
	padding: 10px 0;
	margin: -10px 0;
}

.materials-slider--scroll {
	overflow: visible;
}

.materials-slider__grid {
	display: grid;
	grid-template-columns: repeat(var(--ms-cols, 4), 1fr);
	gap: 20px;
	width: 100%;
	overflow: visible;
	padding: 4px;
	margin-top: 8px;
	margin-bottom: 8px;
}

.materials-slider__grid--scroll {
	max-height: 82vh;
	overflow-y: auto;
	overflow-x: hidden;
	padding-right: 8px;
	padding-bottom: 28px;
	box-sizing: border-box;
	align-content: start;
}

.materials-slider__grid > * {
	overflow: visible;
}

.materials-slider__empty {
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 300px;
}

.materials-slider__empty-text {
	color: rgba(0, 0, 0, 0.15);
	font-family: 'Poppins', Helvetica;
	font-size: 80px;
	font-weight: 800;
	letter-spacing: 0;
	line-height: normal;
	text-align: center;
}

@media (max-width: 1400px) {
	.materials-slider__grid {
		grid-template-columns: repeat(3, 1fr);
	}
}

@media (max-width: 1024px) {
	.materials-slider__grid {
		grid-template-columns: repeat(2, 1fr);
		gap: 15px;
	}

	.materials-slider__empty-text {
		font-size: 60px;
	}
}

@media (max-width: 768px) {
	.materials-slider__grid {
		grid-template-columns: 1fr;
		gap: 12px;
	}

	.materials-slider__empty-text {
		font-size: 40px;
	}
}
</style>
